export const AdministratorGetSchema = {
    id: 'id',
    pages: {
        general: {
            pageId: 'general',
            firstName: 'firstName',
            lastName: 'lastName',
            title: 'title',
            organization: 'organization',
            email: 'email',
            additionalEmails: 'additionalEmails',
            role: 'role',
            roleValues: {
                administrator: 'Administrator',
                readOnly: 'ReadOnly',
                multiDomain: 'MultiDomain',
                multiDomainReadOnly: 'MultiDomainReadOnly'
            },
            password: 'password',
            description: 'description'
        },
        expiration: {
            pageId: 'expiration',
            hasExpiration: 'hasExpiration',
            subscriptionPeriod: 'subscriptionPeriod',
            subscriptionPeriodUnit: 'subscriptionPeriodUnit',
            subscriptionPeriodUnitValues: {
                hours: 'Hours',
                days: 'Days',
                months: 'Months'
            },
            startMode: 'startMode',
            startModeValues: {
                firstLogin: 'FirstLogin',
                specifiedDate: 'SpecifiedDate'
            },
            startDate: 'startDateAndTime',
            userFirstLogin: 'userFirstLogin'
        },
        contact: {
            pageId: 'contact',
            phone: 'phone',
            mobile: 'mobile',
            fax: 'fax',
            address: 'address',
            country: 'country',
            state: 'state',
            zip: 'zip'
        },
        serviceDomains: {
            pageId: 'adminServiceDomains',
            serviceDomainList: 'serviceDomainList'
        },
        twoStepAuth: {
            pageId: 'twoStepAuth',
            isTwoFactorAuth: 'isTwoFactorAuth',
            twoFactorAuthQrUrl: 'twoFactorAuthQrUrl'
        },
        status: {
            pageId: 'status',
            statusDataList: 'statusDataList',
            statusDataSchema: {
                uid: 'uid',
                appName: 'appName',
                creationTime: 'creationTime',
                lastUsedTime: 'lastUsedTime',
                remoteAddress: 'remoteAddress'
            },
            createdDate: 'createdDate',
            modifiedDate: 'modifiedDate'
        }
    }
}

export const AdministratorGetListSchema = {
    userId: 'userId',
    description: 'description',
    firstName: 'firstName',
    lastName: 'lastName',
    email: 'email',
    phone: 'phone',
    role: 'role',
    status: 'status'
}

export const AdministratorStatuses = {
    connected: 'connected',
    disconnected: 'disconnected'
}

export const AdministratorRoles = {
    administrator: 'Administrator',
    readOnly: 'ReadOnly',
    multiDomain: 'MultiDomain',
    multiDomainReadOnly: 'MultiDomainReadOnly'
}

export const AdministratorCreateSchema = {
    name: 'name',
    firstName: 'firstName',
    lastName: 'lastName',
    email: 'email',
    role: 'role',
    roleValues: {
        administrator: 'Administrator',
        readOnly: 'ReadOnly',
        multiDomain: 'MultiDomain',
        multiDomainReadOnly: 'MultiDomainReadOnly'
    },
    password: 'password',
}

export const AdministratorFilterSchema = {
    freeTextSearch: 'freeTextSearch',
    role: 'role',
    roleValues: {
        administrator: 'Administrator',
        readOnly: 'ReadOnly',
        multiDomain: 'MultiDomain',
        multiDomainReadOnly: 'MultiDomainReadOnly'
    },
    creationDate: 'creationDate',
    modificationDate: 'modificationDate'
}